import PropTypes from 'prop-types';

const propTypes = {
  breakpoints: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number
  }),
  colors: PropTypes.shape({
    default: PropTypes.object,
    error: PropTypes.object,
    warning: PropTypes.object,
    success: PropTypes.object,
    black: PropTypes.object,
    dark: PropTypes.object,
    medium: PropTypes.object,
    white: PropTypes.object
  }),
  fontImports: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      light: PropTypes.string,
      lightOblique: PropTypes.string,
      regular: PropTypes.string,
      regularOblique: PropTypes.string,
      heavy: PropTypes.string,
      heavyOblique: PropTypes.string,
      formats: PropTypes.arrayOf(PropTypes.oneOf(['ttf', 'eot', 'woff', 'woff2', 'svg']))
    })
  ),
  font: PropTypes.string,
  preFont: PropTypes.string,
  horizontalGutter: PropTypes.number,
  verticalGutter: PropTypes.number,
  baseSize: PropTypes.number,
  borderRadius: PropTypes.number,
  inputColor: PropTypes.object,
  disabledInputColor: PropTypes.object,
  focusColor: PropTypes.object,
  lineHeight: PropTypes.number
};

const defaultProps = {};

const propDescriptions = '';

const themeProps = {
  propTypes,
  defaultProps,
  propDescriptions
};

export default themeProps;
